// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3Dn3V","Label":"Checkbox_Label__3OmWD","InputElement":"Checkbox_InputElement__R5rw8","Invalid":"Checkbox_Invalid__2einH"};